// extracted by mini-css-extract-plugin
module.exports = {"form":"machinelearningqa_form__W873Y","button":"machinelearningqa_button__qEY0A"};